import { queryOptions, useQuery } from '@tanstack/react-query';

import { queryClient } from '@/slw/shared/query-client';
import { PageResponse } from '@/slw/shared/types/api.type';

import { GetListingsRequest, ListingItem } from './search-results.type';
import { getAllModel, getAllState, getHomeFilter, getListings, getSaveSearch } from './api-client.api';
import { HomeFilterType } from '../home/home.model';

export const LISTINGS_ROOT_QUERY_KEY = ['LISTINGS'];

export const useListingsQuery = (params: GetListingsRequest) => {
  return useQuery(
    queryOptions({
      queryKey: [...LISTINGS_ROOT_QUERY_KEY, params],

      queryFn: async () => {
        const caller = await getListings(params);

        return caller;
      },

      initialData: () => queryClient.getQueryData<PageResponse<ListingItem[]>>([...LISTINGS_ROOT_QUERY_KEY]),

      initialDataUpdatedAt: Date.now(),

      staleTime: 2 * 1000, // 2s
    }),
  );
};

export const useHomeFilterQuery = () => {
  return useQuery(
    queryOptions({
      queryKey: ['HOME_FILTER'],

      queryFn: async () => {
        const caller = await getHomeFilter();

        return caller;
      },

      staleTime: 10 * 60 * 1000, // 1h

      initialData: () => queryClient.getQueryData<PageResponse<HomeFilterType>>([...LISTINGS_ROOT_QUERY_KEY]),

      initialDataUpdatedAt: Date.now(),
    }),
  );
};

export const useAllModelQuery = () => {
  return useQuery(
    queryOptions({
      queryKey: ['ALL_MODEL'],

      queryFn: async () => {
        const caller = await getAllModel();

        return caller;
      },

      staleTime: 10 * 60 * 1000, // 1h
    }),
  );
};

export const useAllStateQuery = () => {
  return useQuery(
    queryOptions({
      queryKey: ['ALL_STATE'],

      queryFn: async () => {
        const caller = await getAllState();

        return caller;
      },

      staleTime: 10 * 60 * 1000, // 1h
    }),
  );
};

export const useSaveSearchQuery = () => {
  return useQuery(
    queryOptions({
      queryKey: ['SAVE_YOUR_SEARCH'],

      queryFn: async () => {
        const caller = await getSaveSearch();

        return caller;
      },
    }),
  );
};
